import React from 'react'
import CecileTableau from '../Artistes/GervaisCecile/imagess/cgbground.jpg'
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'


function Citation() {

    const { t } = useTranslation();

    return (
        <div className="container my-5">

            <h2 className="text-center"> {t('Citation.1')} </h2>

            <div className="row justify-content-md-center ">
                
                    <div className=" col-sm-12 col-md-6 mx-1 my-2">
                        <Link to="/artistes/GervaisCecile">
                            <img src={CecileTableau} className="img-fluid borderBordeaux" width="600px" alt=""  />
                        </Link>
                    </div>
               

                    <div className=" col-sm-12 col-md-4 mx-1 my-2 border border-danger">

                        <Link to="/artistes/GervaisCecile" className="text-decoration-none text-dark">   
                        
                            <div className="float-left">
                                <FormatQuoteIcon  style={{ fontSize: 70 }} htmlColor="#8d010e" />
                            </div>
                        
                            <p className="mt-3 h5">   
                                {t('Citation.2')}

                                <span className="float-right"> 
                                        <FormatQuoteIcon  style={{ fontSize: 70 }} htmlColor="#8d010e" />  
                                </span> 
                            </p>

                        </Link>

                    </div>

                <div className='clearfix'></div>
            </div>
        </div>
    )
}

export default Citation
